/*
 * Copyright (c) 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React, { useMemo } from "react";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { Link } from "react-router-dom";
import ButtonLoading from "../../../Button/ButtonLoading";
import { useForm } from "../../../../provider/Form/FormProvider";
import _isEmpty from "lodash/isEmpty";
import FormSubmitProps from "../../../../types/FormSubmitProps";
import formSubmitStyle from "./formSubmitStyle";
import { Box } from "@mui/material";

export default function FormSubmit({
  hideBackButton = false,
  disabled,
  isLoading = false,
  nextText = "weiter",
  nextButtonSubtext,
  backText = "zurück",
  backLink = "/",
  onBackClick,
}: FormSubmitProps) {
  const { errors }: any = useForm();
  const isValid = useMemo(() => {
    return _isEmpty(errors);
  }, [errors]);
  return (
    <Grid container justifyContent={"center"} alignItems={"baseline"} sx={formSubmitStyle.applicationActions}>
      {!isValid && (
        <Grid item xs={12} sx={formSubmitStyle.invalidContainer}>
          <Grid container justifyContent={"flex-end"}>
            <Grid item xs={12} sm={6} sx={formSubmitStyle.invalidText}>
              Leider sind Ihre Angaben noch nicht richtig oder vollständig. Bitte prüfen Sie Ihre Angaben oben.
            </Grid>
          </Grid>
        </Grid>
      )}
      <Grid item xs={12} sm={6} sx={formSubmitStyle.backButtonContainer}>
        {!hideBackButton && (
          <Button fullWidth variant={"text"} component={Link} sx={formSubmitStyle.backButton} onClick={onBackClick} to={backLink}>
            {backText}
          </Button>
        )}
      </Grid>
      <Grid item sx={formSubmitStyle.submitButtonContainer} xs={12} sm={6}>
        <ButtonLoading fullWidth variant={"contained"} color={"primary"} type={"submit"} disabled={disabled} isLoading={isLoading}>
          {nextText}
        </ButtonLoading>
        {!!nextButtonSubtext && <Box sx={formSubmitStyle.buttonSubtext}>{nextButtonSubtext}</Box>}
      </Grid>
    </Grid>
  );
}
